import styled, { css } from "styled-components";

import base from "@/themes/base/base";

interface SearchBarStylingProps {
    width?: string;
    backgroundColor?: string;
    focus?: boolean;
}

export const SearchBarWrapperDiv = styled.div.withConfig({
    shouldForwardProp: (prop) => !["backgroundColor", "focus"].includes(prop),
})<SearchBarStylingProps>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    width: ${({ width }) => (width ? `${width}` : "18.25rem")};
    background-color: ${({ backgroundColor }) =>
        backgroundColor ? `${backgroundColor}` : `${base.colors.neutral.grey[800]}`};
    border-radius: 2px;
    padding: 0.4375rem 0.75rem;
    border: 1px solid transparent;

    & input {
        ${base.typography.smallRegular};
        color: ${base.colors.neutral.grey[50]};
        background-color: transparent;
        border: none;
        outline: none;
        width: 100%;

        &::placeholder {
            color: ${base.colors.neutral.grey[500]};
        }
    }

    &:hover {
        ${({ focus }) =>
            !focus &&
            css`
                border: 1px solid ${base.colors.neutral.grey[300]};
            `}
    }

    ${({ focus, theme }) =>
        focus &&
        css`
            border: 1px solid ${theme.colors.primary.orange[500]};
        `}
`;

export const IconWrapper = styled.div`
    display: flex;
`;
